import styled from 'styled-components';

const getHeaderPadding = size => {
  switch (size) {
    case 'medium':
      return '16px';
    case 'large':
      return '24px 24px 24px 16px';
    default:
      return '16px';
  }
};

const getHeaderHeight = size => {
  switch (size) {
    case 'medium':
      return '72px';
    case 'large':
      return '88px';
    default:
      return '72px';
  }
};

const Header = styled.div`
  padding: ${props => getHeaderPadding(props.size)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${props => getHeaderHeight(props.size)};
`;

export default Header;
